import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';

export const breadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Students',
    url: '/hub/students'
  },
  {
    label: 'Bulk Upload',
    url: '/hub/students/bulk',
    active: true
  }
];
